/**
 * 问题件上报
 */

export default {
  problem_add_or_modify_name_list: ['69650', '82635'] // 202507230836024478418 问题件上报问题名称
}
